import { ApiProperty } from "@nestjs/swagger";

export class UnitRequest{
    @ApiProperty()
    unitId:number;
    constructor(unitId:number){
        this.unitId = unitId;
    }
}